import classNames from "classnames/bind";
import Button, { THEMES } from "common/blocks/Button";
import useModalContext from "common/providers/modal/useModalContext";

import styles from "./FooterCloseButton.module.scss";

const cx = classNames.bind(styles);

const FooterCloseButton = ({
    theme = "secondary",
    className,
    children,
    type = "sidebar",
}: {
    theme?: (typeof THEMES)[number];
    className?: string;
    children: React.ReactNode;
    type: "sidebar" | "popup";
}) => {
    const { usePopup, useSidebar } = useModalContext();
    const { closeSidebar } = useSidebar();
    const { closePopup } = usePopup();

    return (
        <div className={cx("wrapper", className)}>
            <Button
                theme={theme}
                fullWidth
                onClick={() => (type === "popup" ? closePopup(true) : closeSidebar(true))}
                ariaLabel="Close Sidebar"
            >
                {children}
            </Button>
        </div>
    );
};

export default FooterCloseButton;
